import { AuthService } from 'src/app/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { PDFDocument, StandardFonts } from 'pdf-lib'
import { CoursesService } from 'src/app/services/courses.service';
import { FileHelper } from 'src/app/helpers';
import { Agency, LoggedInUser } from 'src/app/models';

@Component({
  selector: 'app-certificate-rw',
  templateUrl: './certificate-rw.component.html',
  styleUrls: ['./certificate-rw.component.css']
})
export class CertificateRwComponent implements OnInit {
  pdfDoc!: PDFDocument;
  src?: string;
  loading = false;
  loaded = false;
  error?: string;

  user!: LoggedInUser;
  agency!: Agency;

  constructor(private auth: AuthService, public coursesService: CoursesService) { }

  // When the page is loaded, pull the profile infomation
  async ngOnInit(): Promise<void> {
    this.loadData();
  }

  private async loadData() {
    try {
      this.loading = true;
      this.loaded = false;

      // Getting user info
      this.agency = this.coursesService.rentWiseAgency;
      this.user = this.auth.user || {};

      const course = this.coursesService.currentCourse;

      if (!this.agency || !this.user || !course.completionDate) {
        this.error = 'User certificate not found.';
        return;
      }

      // TODO: save certificates on S3 bucket
      this.pdfDoc = await this.coursesService.generateRentwiseCertificate(this.agency, this.user, course.completionDate) as any;

      // Serialize the PDFDocument to data URI for the pdf-viewer
      const pdfDataUri = await this.pdfDoc.saveAsBase64({ dataUri: true });

      this.src = pdfDataUri;

      this.loaded = true;
    }
    finally {
      this.loading = false;
    }
  }

  async downloadPdf () {
    if (!this.pdfDoc) {
      return;
    }

    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfDoc.save();
    FileHelper.saveByteArray('certificate.pdf', pdfBytes, 'application/pdf');
  }
}
